/* global globalThis */
export const PRERENDER_DATA_ID = "prerender-data";

export const readPrerenderData = () => {
  if (typeof document !== "undefined" && typeof document.getElementById === "function") {
    const node = document.getElementById(PRERENDER_DATA_ID);
    if (node?.textContent) {
      try {
        return JSON.parse(node.textContent);
      } catch {
        return null;
      }
    }
    if (typeof window !== "undefined") return null;
  }
  return globalThis.__PAGE_DATA__ || null;
};

export const prerenderTournamentForPath = (pathname) => {
  const data = readPrerenderData();
  if (!data?.tournament?.id || !data.path) return null;
  if (data.path !== pathname) return null;
  return data;
};
